module.exports = __webpack_public_path__ + "img/1iK02QsUrTzFnQmRTmaLa9iE0fdGIWfP7.c920a06b.png";